import React, { useEffect } from 'react';
import styled from 'styled-components';

import { User } from '~/api/account/accountApiTypes';
import { Book } from '~/api/book/bookApiTypes';
import Modal from '~/atomic/molecula/Modal';
import { confirmEmailCode, quickRegister } from '~/feature/authorization/auth.data';
import { authSelector } from '~/feature/authorization/auth.selector';
import { QuickRegisterForm } from '~/feature/authorization/quickAuth/QuickRegisterForm';
import { subscribeBookAndOpenModal } from '~/feature/book/SubscribeBookModal/subscribeBookModal.data';
import { subscribeBookModalSelector } from '~/feature/book/SubscribeBookModal/subscribeBookModal.selector';
import { subscribeBookModalActions } from '~/feature/book/SubscribeBookModal/subscribeBookModal.slice';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { ym } from '~/feature/yandex/YandexMetrikaInit';
import { GraphqlBook } from '~/graphql/books/factory/book/BookFactoryTypes';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

interface Props {
  book?: Partial<GraphqlBook> | Book;
}

export const RegisterModalWithSubscribeBook = ({ book }: Props) => {
  const dispatch = useAppDispatch();
  const { isOpenRegisterModalWithSubscribeBook } = useAppSelector(subscribeBookModalSelector);
  const { quickAuthEmail } = useAppSelector(choosePaySelector);
  const { loading } = useAppSelector(authSelector);

  useEffect(() => {
    if (isOpenRegisterModalWithSubscribeBook) {
      ym('reachGoal', 'open-register-modal');
    }
  }, [isOpenRegisterModalWithSubscribeBook]);

  const closeModal = () => {
    dispatch(subscribeBookModalActions.setIsOpenRegisterModalWithSubscribeBook(false));
  };

  const afterLogin = async (user: User) => {
    dispatch(subscribeBookAndOpenModal({ book }));
    closeModal();
  };

  const confirmQuickRegistration = async () => {
    ym('reachGoal', 'click-quick-register-modal');
    await dispatch(quickRegister({ email: quickAuthEmail, afterLogin }));
  };

  const confirmCode = async (code: string) => {
    ym('reachGoal', 'confirm-code-register');
    await dispatch(confirmEmailCode({ code, afterLogin }));
  };

  const onBackClick = () => {
    closeModal();
    dispatch(subscribeBookModalActions.setIsOpenAuthModalWithSubscribeBook(true));
  };

  return (
    <SCAuthModal
      onCancel={closeModal}
      open={isOpenRegisterModalWithSubscribeBook}
    >
      <QuickRegisterForm
        onBackClick={onBackClick}
        confirmQuickRegistration={confirmQuickRegistration}
        confirmCode={confirmCode}
        isLoading={loading.quickRegister === true || loading.confirmEmailCode === true}
        email={quickAuthEmail}
        nextButtonText="Войти"
        label={(
          <>
            Не хочу отвлекаться от чтения!
            <br />
            Подтверждаю, что адрес почты указан верно.
            <br />
            Для последующего входа в аккаунт попрошу прислать код на почту.
          </>
        )}
      />
    </SCAuthModal>
  );
};

export const SCAuthModal = styled(Modal)`
  max-width: 458px;

  .ant-modal-body {
    padding-top: 23px;
    padding-bottom: 23px;
  }

  ${lessThan('xs')} {
    max-width: 100vw;
    top: 0;
  }
`;
